import PendoButton from '../../../components/button/pendo-button.vue.js';
import PendoTable from '../../../components/table/pendo-table.vue.js';
import PendoTabs from '../../../components/tabs/pendo-tabs.vue.js';
import PendoTabPanel from '../../../components/tabs/pendo-tab-panel.vue.js';
import PendoCsvModal from '../../csv-modal/pendo-csv-modal.vue.js';
import PendoStatusOverlay from '../../status-overlay/pendo-status-overlay.vue.js';
import get from 'lodash/get.js';

var script = {
  name: 'PendoGuideMetricsDrawerContent',
  components: {
    PendoButton,
    PendoTable,
    PendoTabs,
    PendoTabPanel,
    PendoCsvModal,
    PendoStatusOverlay
  },
  props: {
    csvDownloadAggId: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => ({
        accounts: [],
        visitors: []
      })
    },
    loading: {
      type: Boolean,
      default: false
    },
    csvModalStatus: {
      type: String,
      default: 'loading'
    },
    csvUrl: {
      type: String,
      default: ''
    },
    visitorUrl: {
      type: String,
      default: ''
    },
    accountUrl: {
      type: String,
      default: ''
    },
    showCreateSegment: {
      type: Boolean,
      default: false
    },
    showAccountsTab: {
      type: Boolean,
      default: true
    },
    showClicksColumn: {
      type: Boolean,
      default: false
    },
    aggStatus: {
      type: Object,
      default: () => ({
        accounts: null,
        visitors: null
      })
    }
  },
  data() {
    return {
      activeTab: 'visitor',
      showCsvModal: false
    };
  },
  computed: {
    tabs() {
      return [{
        label: 'Visitors',
        prop: 'visitor',
        data: get(this.data, 'visitors') || [],
        aggStatus: get(this.aggStatus, 'visitors')
      }, this.showAccountsTab && {
        label: 'Accounts',
        prop: 'account',
        data: get(this.data, 'accounts') || [],
        aggStatus: get(this.aggStatus, 'accounts')
      }].filter(Boolean);
    },
    tableColumns() {
      return [this.activeTab === 'visitor' && {
        href: row => {
          if (!this.visitorUrl) {
            return false;
          }
          if (row.href) {
            return row.href;
          }
          return `${this.visitorUrl}/${encodeURIComponent(row.id)}`;
        },
        label: 'Visitor ID',
        prop: 'id',
        sortable: true,
        target: '_blank',
        type: 'link'
      }, this.activeTab === 'account' && {
        href: row => {
          if (row.id === '(none)' || !this.accountUrl) {
            return false;
          }
          if (row.href) {
            return row.href;
          }
          return `${this.accountUrl}/${encodeURIComponent(row.id)}`;
        },
        label: 'Account ID',
        prop: 'id',
        sortable: true,
        target: '_blank',
        type: 'link'
      }, this.showClicksColumn && {
        label: 'Clicks',
        prop: 'clicks',
        sortable: true,
        width: 120
      }].filter(Boolean);
    }
  },
  methods: {
    downloadCsv() {
      this.showCsvModal = true;
      this.$emit('download-csv', {
        activeTab: this.activeTab,
        csvDownloadAggId: this.csvDownloadAggId
      });
    },
    createSegment() {
      this.$emit('create-segment', this.activeTab);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-guide-metrics-drawer-content.vue2.js.map
